import React, { Component, PropTypes } from 'react';
import { browserHistory, withRouter } from 'react-router';
import { connect } from 'react-redux';
import { fetchEvent, fetchEvents } from '../actions/';
import autoBind from 'react-autobind';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import ViewEvent from '../components/events/ViewEvent';

const propTypes = {
  dispatch: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  event: PropTypes.object,
  error: PropTypes.any,
  query: PropTypes.object.isRequired,
  router: PropTypes.object,
  params: PropTypes.object,
};

class EventViewPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alertOpen: false,
      alertMessage: '',
      edited: false,
    };
    autoBind(this);
  }
  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }
  componentWillMount() {
    if (!this.props.isAuthenticated) {
      browserHistory.push('/');
    }
    this.props.dispatch(fetchEvent(this.props.params.id));
  }
  componentWillReceiveProps(nextProps) {
    const event = nextProps.event;
    this.setState({ event });
  }
  navigation(route) {
    this.props.dispatch(fetchEvents(route));
  }
  render() {
    const authPage = {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
    };
    return (
      <div className="events component" style={authPage}>
        <h2>View Event</h2>
        <ViewEvent
          event={this.state.event}
          onSave={data => this.saveEditEvent(data)}
          onView={data => this.navigateToView(data)}
        />
      </div>
    );
  }
}

EventViewPage.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

EventViewPage.propTypes = propTypes;

function mapStateToProps(state, ownProps) {
  const event = state.events.event;
  return {
    isAuthenticated: state.auth.isAuthenticated,
    event,
    eventId: ownProps.params.eventId,
    query: ownProps.location.query,
  };
}

export default withRouter(connect(mapStateToProps)(EventViewPage));



// WEBPACK FOOTER //
// ./src/containers/EventViewPage.js